import { ApiResponseType } from './api';
import { axiosInstance } from './index';
import {photoaxiosInstance} from './index';


export const commonService = {
   
   async getDoctorDetailsforApproval(){
        const { data: responseData } = await axiosInstance.get(`common/getDoctorDetailsForApproval`);
        return responseData;
},
   
async saveDoctorPhoto(data: any){
        const { data: responseData } = await photoaxiosInstance.post(`files/upload`,data);
        return responseData;
},

async updateDoctorApprovals(data: any){
    const { data: responseData } = await axiosInstance.post(`common/docApproval`,data);
        return responseData;
},

async getDropDownValues(dropDownName: any){
    const { data: responseData } = await axiosInstance.get(`common/getDropDownValues`,dropDownName);
        return responseData;
},

async getDropDownValuesByParentId(formdata: any){      
    const { data: responseData } = await axiosInstance.get(`common/getDropDownValuesByParentId`,formdata,);
        return responseData;
},
}